import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import HomeWorkOutlined from '@material-ui/icons/HomeWorkOutlined';
import RoomOutlined from '@material-ui/icons/RoomOutlined';
import MyLocationRounded from '@material-ui/icons/MyLocationRounded';
import { FormSection, SelectInput, TextInput } from './LoanFormFields';

// Property and address sections of the Add / Edit loan form. Same fields and
// handlers as before (Property name and Basement stay switched off);
// `errors` shows the failed check inline.
export const STRUCTURE_TYPE = [{ id: '1', name: 'RCC Frame' }, { id: '2', name: 'Load Bearing' }];
export const FLOOR_NUMBERS = [{ id: 1, name: 'GROUND' }, { id: 2, name: 'GROUND +1' }, { id: 3, name: 'GROUND +2' }];

export default function FormLoanProperty({ newProperty = {}, setNewProperty, errors = {} }) {
  const set = (obj) => setNewProperty({ ...newProperty, ...obj });

  return (
    <>
      <FormSection title='Property' icon={<HomeWorkOutlined />}>
        <SelectInput
          id='structureType'
          label='Structure type'
          span={2}
          required
          error={errors.structureType}
          options={STRUCTURE_TYPE.map((t) => ({ value: t.id, label: t.name }))}
          value={newProperty.structureType}
          onChange={(e) => set({ structureType: e.target.value === '#78' ? null : e.target.value })}
        />
        <SelectInput
          id='noOfFloors'
          label='No of floors'
          span={2}
          required
          error={errors.noOfFloors}
          options={FLOOR_NUMBERS.map((f) => ({ value: f.id, label: f.name }))}
          value={newProperty.noOfFloors}
          onChange={(e) => set({ noOfFloors: e.target.value === '#78' ? null : e.target.value })}
        />
        <TextInput
          id='landArea'
          label='Land area'
          span={2}
          type='number'
          suffix='sq ft'
          value={newProperty.landArea}
          onChange={(e) => set({ landArea: e.target.value })}
        />
        <TextInput
          id='builtUpArea'
          label='Built-up area'
          span={2}
          required
          type='number'
          suffix='sq ft'
          error={errors.builtUpArea}
          value={newProperty.builtUpArea}
          onChange={(e) => set({ builtUpArea: e.target.value })}
        />
        <TextInput
          id='propertyDescription'
          label='Property details'
          span={4}
          multiline
          value={newProperty.propertyDescription}
          onChange={(e) => set({ propertyDescription: e.target.value })}
        />
      </FormSection>

      <FormSection title='Address & location' icon={<RoomOutlined />}>
        <TextInput
          id='addressLine1'
          label='Address line 1'
          span={4}
          multiline
          value={newProperty.addressLine1}
          onChange={(e) => set({ addressLine1: e.target.value })}
        />
        <TextInput
          id='addressLine2'
          label='Address line 2'
          span={4}
          multiline
          value={newProperty.addressLine2}
          onChange={(e) => set({ addressLine2: e.target.value })}
        />
        {/* Coordinates place the loan on the map and check site photos:
            set apart so they are not missed. */}
        <div className='lf-geo lf-span-4'>
          <div className='lf-geo-title'>
            <MyLocationRounded />
            GPS coordinates
          </div>
          <div className='lf-grid'>
            <TextInput
              id='lat'
              label='Latitude'
              span={6}
              type='number'
              error={errors.lat}
              value={newProperty.lat}
              onChange={(e) => set({ lat: e.target.value })}
            />
            <TextInput
              id='lng'
              label='Longitude'
              span={6}
              type='number'
              error={errors.lng}
              value={newProperty.lng}
              onChange={(e) => set({ lng: e.target.value })}
            />
          </div>
        </div>
        <TextInput
          id='cityTown'
          label='City'
          span={2}
          value={newProperty.cityTown}
          onChange={(e) => set({ cityTown: e.target.value })}
        />
        <TextInput
          id='district'
          label='District'
          span={2}
          value={newProperty.district}
          onChange={(e) => set({ district: e.target.value })}
        />
        <TextInput
          id='state'
          label='State'
          span={2}
          value={newProperty.state}
          onChange={(e) => set({ state: e.target.value })}
        />
        <TextInput
          id='pincode'
          label='Pincode'
          span={2}
          type='number'
          value={newProperty.pincode}
          onChange={(e) => set({ pincode: e.target.value })}
        />
      </FormSection>
    </>
  );
}
